import React from 'react'
import "../App.css"
import { Badge, Button, Card } from 'react-bootstrap'
import health from '../Images/health.jpg';
import { Link } from 'react-router-dom';
import heartpng from '../Images/logoimg.png'
function About() {
  return (
    <div>
        <h2 className='serv'><img className='heartpng' width={40} src={heartpng} alt="" /> About Us</h2>
        <p className='ms-3 me-3 about'>Our medical practice was initiated by our founder, V.M. Daniel, in 1960 and subsequently established in Kulanada in 2002. We have been committed to providing unparalleled service and top-notch pharmaceutical products to our valued customers. Our extensive range of medications encompasses offerings from all major pharmaceutical companies, ensuring that our clients have access to the highest quality treatments available on the market.
        With over two decades of experience in the industry, our team possesses the expertise and knowledge necessary to cater to the diverse needs of our clientele. We understand the critical importance of administering medications with the utmost care and precision, which is why we meticulously select and source only the finest pharmaceutical products.
        At our facility, quality is our top priority. We adhere to stringent quality control measures at every stage of the procurement and distribution process, guaranteeing that each medication meets the highest standards of safety and efficacy. Our dedication to excellence has earned us the trust and loyalty of countless individuals and healthcare professionals over the years and we extend our deepest gratitude to our esteemed customers for their unwavering support and confidence in our services.






</p>

        <div className='mt-3 mb-3'>
      <Card className='healthcardmain' >
      <div className='healthcard'>
      <Card.Img className='cardimg' variant="top" src={health} />
      <Card.Body>
        <Card.Title className='abouthead' style={{fontFamily:'philosopher',textAlign:'center'}}>Health Care <span className='badgespan'><Badge className='badge' bg="warning">New</Badge></span></Card.Title>
        <Card.Text style={{fontFamily:'Mooli',textAlign:'justify'}}>
          We are excited to introduce our new Wellness Collection in our store. Discover a range of products designed to promote your well-being and enhance your daily routine.
          We are dedicated to offering a wide range of high-quality products, from supplements and vitamins to personal care items and medical supplies, all designed to support your well-being.
          Our carefully curated selection ensures you have access to trusted brands and the latest health innovations.
          Whether you're looking to boost your immunity, manage a condition, or enhance your overall health, our Health Care section is here to help you lead a healthier, happier life.  
          <span style={{fontWeight:'bolder'}}>Visit us today</span> to explore our latest additions and find everything you need to support a healthier lifestyle.
        </Card.Text>
        <Link to={'/health'} className='btn btn-success text-white w-100' >More Details</Link>
      </Card.Body>
      </div>
    </Card>
 </div>
    </div>
  )
}

export default About